// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__exjaZ","text":"text__RzPAh","description":"description__2HhPf","button-wrapper":"button-wrapper__1exnl"};